<template>
<div class="chapter">
<div class="inner_page">
<p class="image"><img alt="images" src="images/f009-02.jpg" width="80%"/></p>
<p class="caption"><em class="italic">The CWGC sign that is found at the entrance of communal cemeteries where Commonwealth war dead are buried</em>.</p>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// 08_fm023.vue?12decc08